import { ContractChangeValidationListFragment } from '../../../../types'
import {
  getContractChangeValuesForLastDefinedMonth,
  getUndefinedContractChangeValuesForGivenMonth,
  UndefinedContractChangeValuesForGivenMonth,
} from './validationHelpers'

export type SalaryAndBonusTransferValidationType = {
  valid: boolean
  minimalValidValue?: number
  futurePackageDecrease?: boolean
}

export const salaryAndBonusTransferValidation = (
  date: Date,
  salary: number,
  bonus: number,
  contractChangeValidationList: ContractChangeValidationListFragment,
): SalaryAndBonusTransferValidationType => {
  const contractChangeValuesForNextFirstDefinedMonth: UndefinedContractChangeValuesForGivenMonth = getContractChangeValuesForLastDefinedMonth(
    contractChangeValidationList,
  )
  if (
    contractChangeValuesForNextFirstDefinedMonth &&
    bonus + salary < contractChangeValuesForNextFirstDefinedMonth.bonus + contractChangeValuesForNextFirstDefinedMonth.salary
  ) {
    return {
      valid: false,
      minimalValidValue: contractChangeValuesForNextFirstDefinedMonth.bonus + contractChangeValuesForNextFirstDefinedMonth.salary,
      futurePackageDecrease: true,
    }
  }

  const contratChangeValuesForGivenMonth: UndefinedContractChangeValuesForGivenMonth = getUndefinedContractChangeValuesForGivenMonth(
    date,
    contractChangeValidationList,
  )
  const minimalValidValue: number = contratChangeValuesForGivenMonth.bonus + contratChangeValuesForGivenMonth.salary
  if (bonus + salary <= minimalValidValue) {
    return {
      valid: false,
      minimalValidValue: minimalValidValue,
    }
  }

  return { valid: true }
}
